import get from 'lodash.get';

const getInitialSettingsApplied = (rootState) =>
  get(rootState, 'ws.site.properties.initialSettingsApplied', false);

export default getInitialSettingsApplied;
